import { render } from "./DeleteProductModal.vue?vue&type=template&id=38f846da&scoped=true"
import script from "./DeleteProductModal.vue?vue&type=script&lang=js"
export * from "./DeleteProductModal.vue?vue&type=script&lang=js"

import "./DeleteProductModal.vue?vue&type=style&index=0&id=38f846da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38f846da"]])

export default __exports__